module.exports = __webpack_public_path__ + "static/media/11NEPAD10.c50a10f0.jpg";